// src/styles/themes.js

const themes = {
  Theme: {
    icon: "🎨",
    image: null,
    imageMini: null,
    gradient: "transparent", // Transparent background
  },
  Faith: {
    icon: "/themes/icons/faith.png",
    image: "/themes/cards/faith.jpg",
    imageMini: "/themes/thumbnails/faith.jpg",
    gradient: "linear-gradient(160deg, #76716B 0%, #52483F 100%)",
  },
  Abide: {
    icon: "/themes/icons/abide.png",
    image: "/themes/cards/abide.jpg",
    imageMini: "/themes/thumbnails/abide.jpg",
    gradient: "linear-gradient(160deg, #7C7771 0%, #44385E 100%)",
  },
  Devotion: {
    icon: "/themes/icons/devotion.png",
    image: "/themes/cards/devotion.jpg",
    imageMini: "/themes/thumbnails/devotion.jpg",
    gradient: "linear-gradient(160deg, #AE989A 0%, #624F51 100%)",
  },
  Adoration: {
    icon: "/themes/icons/adoration.png",
    image: "/themes/cards/adoration.jpg",
    imageMini: "/themes/thumbnails/adoration.jpg",
    gradient: "linear-gradient(160deg, #72201C 0%, #2E181B 100%)",
  },
  Blaze: {
    icon: "/themes/icons/blaze.png",
    image: "/themes/cards/blaze.jpg",
    imageMini: "/themes/thumbnails/blaze.jpg",
    gradient: "linear-gradient(160deg, #AD5B21 0%, #60110C 100%)",
  },
  Ember: {
    icon: "/themes/icons/ember.png",
    image: "/themes/cards/ember.jpg",
    imageMini: "/themes/thumbnails/ember.jpg",
    gradient: "linear-gradient(160deg, #A26610 0%, #5B280B 100%)",
  },
  Joy: {
    icon: "/themes/icons/joy.png",
    image: "/themes/cards/joy.jpg",
    imageMini: "/themes/thumbnails/joy.jpg",
    gradient: "linear-gradient(160deg, #A39051 0%, #958055 100%)",
  },
  Radiance: {
    icon: "/themes/icons/radiance.png",
    image: "/themes/cards/radiance.jpg",
    imageMini: "/themes/thumbnails/radiance.jpg",
    gradient: "linear-gradient(160deg, #DED77F 0%, #6E5C2E 100%)",
  },
  Renew: {
    icon: "/themes/icons/renew.png",
    image: "/themes/cards/renew.jpg",
    imageMini: "/themes/thumbnails/renew.jpg",
    gradient: "linear-gradient(160deg, #C2BDAA 0%, #5D5D37 100%)",
  },
  Rooted: {
    icon: "/themes/icons/rooted.png",
    image: "/themes/cards/rooted.jpg",
    imageMini: "/themes/thumbnails/rooted.jpg",
    gradient: "linear-gradient(160deg, #928857 0%, #3d472b 100%)",
  },
  Haven: {
    icon: "/themes/icons/haven.png",
    image: "/themes/cards/haven.jpg",
    imageMini: "/themes/thumbnails/haven.jpg",
    gradient: "linear-gradient(160deg, #55819A 0%, #1E3D4D 100%)",
  },
  Wonder: {
    icon: "/themes/icons/wonder.png",
    image: "/themes/cards/wonder.jpg",
    imageMini: "/themes/thumbnails/wonder.jpg",
    gradient: "linear-gradient(160deg, #20406F 0%, #08234D 100%)",
  },
};

export default themes;
